export function CaregiverEnrollmentDetails (): JSX.Element {
  return <>This feature is not implemented yet</>
}
